export default __webpack_public_path__ + "static/media/IMG_0010_1_11zon.dff9ad5f.jpg";